import type { PropsWithChildren } from "react";

type RenderProps = {
  if?: boolean;
};
type Props = PropsWithChildren<RenderProps>;

// See https://bloggie.io/@_ChristineOo/conditionally-rendering-react-components-in-typescript

export const Render = (props: Props): JSX.Element | null => {
  const renderIf = props.if === undefined || !!props.if;
  if (!renderIf) return null;
  return <>{props.children}</>;
};
